import * as XLSX from 'xlsx';

export const POWERED_BY_SUITE241 = 'powered by Suite241';
export const POWERED_BY_METADATA = { powered_by: 'Suite241' } as const;

export function appendPoweredByWorksheet(worksheet: XLSX.WorkSheet): void {
  const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:A1');
  const row = range.e.r + 2;
  const columns = Math.max(range.e.c + 1, 1);
  XLSX.utils.sheet_add_aoa(worksheet, [[POWERED_BY_SUITE241]], { origin: { r: row, c: 0 } });
  worksheet['!merges'] = [...(worksheet['!merges'] || []), { s: { r: row, c: 0 }, e: { r: row, c: columns - 1 } }];
  const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: 0 })];
  if (cell) cell.s = { alignment: { horizontal: 'center' }, font: { sz: 8 } };
}

export const poweredByPrintHtml = `<div style="margin-top:18px;text-align:center;font-size:9px;color:#666">${POWERED_BY_SUITE241}</div>`;
